import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Lock, Mail, Phone, User, Info, Download
} from 'lucide-react';

const settingsOptions = [
  {
    label: 'Change Password',
    description: 'Update your login password securely',
    icon: <Lock className="w-6 h-6 text-indigo-600" />,
    route: '/settings/change-password',
  },
  {
    label: 'Update Email',
    description: 'Modify your registered email',
    icon: <Mail className="w-6 h-6 text-indigo-600" />,
    route: '/settings/update-email',
  },
  {
    label: 'Update Mobile',
    description: 'Change your phone number',
    icon: <Phone className="w-6 h-6 text-indigo-600" />,
    route: '/settings/update-mobile',
  },
  {
    label: 'Update Profile Info',
    description: 'Edit name, address, and more',
    icon: <User className="w-6 h-6 text-indigo-600" />,
    route: '/settings/edit-profile',
  },
  {
    label: 'View Registered Info',
    description: 'See your current profile details',
    icon: <Info className="w-6 h-6 text-indigo-600" />,
    route: '/settings/profile',
  },
  {
    label: 'Download Hall Ticket',
    description: 'Get your latest contest ticket',
    icon: <Download className="w-6 h-6 text-indigo-600" />,
    route: '/settings/hall-ticket',
  },
];

const Settings: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="max-w-5xl mx-auto mt-20 px-4">
      <h1 className="text-3xl font-bold text-center text-indigo-700 mb-10">Settings</h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {settingsOptions.map((option, index) => (
          <div
            key={index}
            onClick={() => navigate(option.route)}
            className="cursor-pointer p-6 bg-white shadow-md rounded-xl hover:shadow-lg transition duration-300 border hover:border-indigo-400"
          >
            <div className="flex items-center space-x-4 mb-2">
              {option.icon}
              <h2 className="text-lg font-semibold text-gray-800">{option.label}</h2>
            </div>
            <p className="text-gray-600 text-sm">{option.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Settings;
